import { render, staticRenderFns } from "./AccountGroupAddNew.vue?vue&type=template&id=043a8541"
import script from "./AccountGroupAddNew.vue?vue&type=script&lang=js"
export * from "./AccountGroupAddNew.vue?vue&type=script&lang=js"
import style0 from "./AccountGroupAddNew.vue?vue&type=style&index=0&id=043a8541&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports